import {FC} from 'react'

import {theme} from '@/theme/theme'

import {FormRemoveButton} from './FormRemoveButton'

type FormSelectedItemProps = {
  onClick?: () => void
}

export const FormSelectedItem: FC<React.PropsWithChildren<FormSelectedItemProps>> = ({
  onClick,
  children,
}) => (
  <>
    <li className="item">
      {children}
      {onClick && <FormRemoveButton onRemove={onClick} />}
    </li>

    <style jsx>{`
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${theme.spacing[3]};
        padding: ${theme.spacing[3]} 0;
      }
      .item:first-child {
        padding-top: 0;
      }
      .item:last-child {
        padding-bottom: 0;
      }
      .item + .item {
        border-top: 1px solid ${theme.palette.gray[200]};
      }
    `}</style>
  </>
)
